export default {
  user: {
    settings: {},
    clients: [],
  },
  clientUsers: [],
};

export const component = 'user/';
